/**
 * 매장 상세 마감 시간까지 남은 시간 (HH:MM:SS) 주기 갱신.
 * store page 전용 hook.
 */
import { useState, useEffect } from "react";
import { getTimeLeftFromClosingHours } from "../utils/store-time";

export function useStoreTimers(closingHours: string | null | undefined): string {
  const [timeLeft, setTimeLeft] = useState<string>("");

  useEffect(() => {
    if (!closingHours) return;
    const tick = () => setTimeLeft(getTimeLeftFromClosingHours(closingHours));
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [closingHours]);

  return timeLeft;
}
